import { ProgressBarSize } from "./types";

export const PHRASES = [
  "Rustling up your data...",
  "Herding the bytes...",
  "Blazing the upload trail...",
  "Wrangling the files...",
  "Saddling up the servers...",
  "Riding the data range...",
  "Corralling the uploads...",
  "Breaking new ground...",
  "Hitching up the bandwidth...",
  "Moseying through the process...",
  "Rounding up the results...",
  "Taming the wild uploads...",
  "Drawing from the data well...",
  "Spinning up the transfer...",
  "Pioneering the digital frontier...",
  "Loading up the wagon...",
];

export const sizeClasses = {
  [ProgressBarSize.SMALL]: {
    container: "h-1 max-w-[80px]",
    text: "text-xs",
  },
  [ProgressBarSize.MEDIUM]: {
    container: "h-2 max-w-[150px]",
    text: "text-xs",
  },
  [ProgressBarSize.LARGE]: {
    container: "h-3 max-w-[200px]",
    text: "text-sm",
  },
};
